export const INITIAL_STATE = {
  AUTH: {
    isAuthenticated: false,
    userData: {},
    authLoading: false,
    birthDays: [],
    allBirthDays: [],
    weatherLocale: {},
    users: [],
    notifications: []
  },

  TABLEAU : {
    tableau: ''
  },

  SYSTEM: {
    toast: {
      open: false,
      message: '',
      type: 'error',
    },
    linkMaisManserv: ''
  },
  BANNERS: {
    banners: [],
    bannerInfo: {},
    homeBanners: [],
  },
  CONTRACTS: {
    contracts: [],
    contractInfo: {},
  },
  COMMUNICATED: {
    communicated: [],
    templates: [],
    template: {},
    communicatedInfo: {},
  },
  APPS: {
    apps: [],
    favoriteApps: [],
  },
};
